import React from 'react';

import AtlassianIntelligenceIconCore from '@atlaskit/icon/core/atlassian-intelligence';

export const AtlassianIntelligenceIcon = () => (
	<AtlassianIntelligenceIconCore label="" spacing="spacious" />
);
